import React, { useEffect, useState } from "react";
import { businessMatchingRootPath, postsPath, studyGroupsPath } from "../../../../../../routes";
import { SharedCurrentUser } from "../../../lib/types";

import { Box, HStack, Link } from "@chakra-ui/react";

const hoverStyle = { backgroundColor: "#EDF5F3" };

export const ServiceLinks = ({ currentUser }: { currentUser?: SharedCurrentUser }) => {
  const [currentLocation, setCurrentLocation] = useState<Location>();

  useEffect(() => {
    setCurrentLocation(location);
  }, []);

  const activeProps = {
    borderBottom: "4px solid",
    borderColor: "primary",
    fontWeight: "bold",
  };

  return (
    <HStack h="full">
      <Link
        px={6}
        href={postsPath()}
        textDecoration="none"
        color="inherit"
        {...(currentLocation?.pathname?.startsWith("/posts") && activeProps)}
        _hover={hoverStyle}
        h="full"
        placeContent="center"
      >
        <Box pt={0.5} as="span">
          Q&A
        </Box>
      </Link>
      <Link
        px={6}
        href={studyGroupsPath()}
        textDecoration="none"
        color="inherit"
        {...(currentLocation?.pathname?.startsWith("/study_groups") && activeProps)}
        _hover={hoverStyle}
        h="full"
        placeContent="center"
      >
        <Box pt={0.5} as="span">
          勉強会
        </Box>
      </Link>
      {currentUser?.is_show_business_matching_link && (
        <Link
          px={6}
          href={businessMatchingRootPath()}
          textDecoration="none"
          color="inherit"
          {...(currentLocation?.pathname?.startsWith("/business_matching") && activeProps)}
          _hover={hoverStyle}
          h="full"
          placeContent="center"
          isExternal
        >
          <Box pt={0.5} as="span">
            協力事務所を探す（β版）
          </Box>
        </Link>
      )}
    </HStack>
  );
};
